import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import Icon from './Icon';

export default class FieldDisplay extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    label: PropTypes.any,
    spacer: PropTypes.bool,
    inline: PropTypes.bool,
    hideColon: PropTypes.bool,
    value: PropTypes.any,
    tooltipText: PropTypes.string
  }

  static defaultProps = {
    className: ''
  }

  render() {
    let classes = `${this.props.className} field-display`;
    if (this.props.spacer){
      classes += ' spacer';
    }

    const tooltip = this.props.tooltipText ?
      <OverlayTrigger placement="top" overlay={(
        <Tooltip>
          {this.props.tooltipText}
        </Tooltip>)}
      >
        <Icon iconType="info-outline" additionalClasses="m-l-5 zmdi-hc-lg text-info" />
      </OverlayTrigger> : null;

    if (this.props.inline) {
      return (
        <span className={`${classes} inline`}>
          <span className="field-display-label">{this.props.label}{this.props.hideColon ? '' : ':'}</span> <span className="field-display-value">{this.props.value}</span>
        </span>);
    } else {
      return (
        <div className={`${classes} not-inline`}>
          <div className="field-display-label">{this.props.label}{tooltip}</div>
          <div className="field-display-value">{this.props.value}</div>
        </div>);
    }
  }
}
